import { EventTypeLevel } from '../types/ViewModel/EventTypeLevel';
import { EventTypeGroup } from '../types/ViewModel/EventTypeGroup';
import EventTypeGroupFactory from './EventTypeGroupFactory';
import { EventTypeLevelBM } from '../types/BusinessModel/EventTypeLevelBM';
import { EventType } from '../types/ViewModel/EventType';

export default () => {
    const { newEventTypeGroup } = EventTypeGroupFactory();

    const newEventTypeLevelArray = (eventTypeLevelArray: EventTypeLevelBM[]): EventTypeLevel[] => {
        const groupLevelArray: EventTypeLevel[] = [];
        if (eventTypeLevelArray && eventTypeLevelArray.length > 0) {
            eventTypeLevelArray.forEach((level) => {
                const levelItem = createNewLevelItem(level);
                groupLevelArray.push(levelItem);
                levelItem.eventTypeGroupArray.forEach((b) => {
                    b.eventTypeLevel = levelItem;
                });
            });
        }
        groupLevelArray.forEach((level) => {
            level.eventTypeGroupArray.forEach((group) => {
                group.requiredConditionalMandatoryArray?.forEach((rcm) => {
                    const reqEvType = getEventType(rcm.requiredPreviousTypeId, groupLevelArray);
                    if (reqEvType) {
                        rcm.requiredPreviousTypeName = reqEvType.name;
                    }
                    const notAfterEvType = getEventType(rcm.notAfterEventTypeId, groupLevelArray);
                    if (notAfterEvType) {
                        rcm.notAfterEventTypeName = notAfterEvType.name;
                    }
                });
            });
        });
        return groupLevelArray;
    };

    // Finds the event type in the event type level hierarchy
    const getEventType = (eventTypeId: number, eventTypeLevelArray: EventTypeLevel[]): EventType | null => {
        if (eventTypeLevelArray && eventTypeLevelArray.length > 0) {
            const grArray = eventTypeLevelArray.flatMap((o) => o.eventTypeGroupArray);
            const typeArray = grArray.flatMap((o) => o.eventTypeArray);
            const type = typeArray.find((o) => o && o.eventTypeId === eventTypeId);
            return type ?? null;
        }
        return null;
    };

    const createNewLevelItem = (item: EventTypeLevelBM): EventTypeLevel => {
        const groupArray: EventTypeGroup[] = [];
        item.eventTypeGroupList.map((gr) => {
            const newGr = newEventTypeGroup(gr, item.eventTypeLevelId);
            if (newGr) {
                groupArray.push(newGr);
            }
        });
        return new EventTypeLevel(item.eventTypeLevelId, item.name, item.eventTypeContextId, groupArray);
    };

    return {
        newEventTypeLevelArray,
        createNewLevelItem,
    };
};
